import { render } from "./LibManager.vue?vue&type=template&id=5b324840"
import script from "./LibManager.vue?vue&type=script&lang=js"
export * from "./LibManager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__